// Trick to cache busting the url
export const disableCacheUrl = (originalUrl) => {
    return `${originalUrl}${originalUrl?.includes("?") ? "&" : "?"}reload=${Date.now()}`;
};